var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
const initialState = {
    data: [],
    loading: false,
    count: 0,
    error: '',
};
export const fetchAllSteps = createAsyncThunk('steps/fetchAll', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.steps.fetchAll({ page_size: 1000 });
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
const { reducer } = createSlice({
    name: 'reduxSteps',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // FETCH ALL STEPS
        builder.addCase(fetchAllSteps.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAllSteps.fulfilled, (state, { payload }) => {
            state.data = payload.results;
            state.loading = false;
        });
        builder.addCase(fetchAllSteps.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
    },
});
export default reducer;
